import React, { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import { update_paso } from "../services/procesoMatricula/procesoMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";

const ModalConfirmacionSeguro = () => {
  let { obtenerDatosEstudiante } = useMatricula();
  let { setPasoProcesoM, setLoading, setErrorServices } = useProcesoMatricula();

  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  useEffect(() => {
    setErrorServices(false);
  }, [])

  useEffect(() => {
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        msj_anadido: obtenerLabelEtiqueta(
          "lbl_seguro_msj_anadido",
          listadoEtiquetas
        ),
        datos_continuar: obtenerLabelEtiqueta(
          "lbl_update_datos_continuar",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const { msj_anadido, datos_continuar } = etiquetas;

  const validarBtnTieneSeguro = async () => {

    try {
      setLoading(true);
      let updatePaso = await update_paso(obtenerDatosEstudiante, 3, 1);
      if (updatePaso.StatusCode == 200 && updatePaso.Code == 1) {

        let convertirPasoCompletadoMayoCero = Number(updatePaso.Data.paso_siguiente)
        let convertirPasoCompletado = convertirPasoCompletadoMayoCero > 0 ? convertirPasoCompletadoMayoCero - 1 : convertirPasoCompletadoMayoCero
        setPasoProcesoM(convertirPasoCompletado);

      } else {
        throw 'Error de updatepaso'
      }
    } catch (error) {
      setLoading(false);

      let modalErrorr = document.querySelector("#modalErr");

      if (modalErrorr) {
        modalErrorr.click();
        setErrorServices(true)
      }
    } finally {
      setLoading(false);
    }


  };

  return (
    <div
      className="modal fade"
      id="agregarSeguro"
      tabIndex={-1}
      data-bs-backdrop="static"
      aria-labelledby="exampleModalLabel1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-bottom-0 d-none">
            <h5 className="modal-title" id="exampleModalLabel1" />
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body pb-0 pt-4">
            <div className="text-center">
              <div className=" va-middle add-cart">
                <div className="success-animation">
                  <svg
                    className="checkmark-animation"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx={26}
                      cy={26}
                      r={25}
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                </div>
              </div>
              <h5 className="text-uppercase" style={{ paddingLeft: '90px', paddingRight: '90px' }} >
                {/* SE HA AÑADIDO SEGURO UPCH <br />A SU CARRITO DE PAGO */}
                {msj_anadido}
              </h5>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={validarBtnTieneSeguro}
            >
              {datos_continuar}
            </button>
          </div>
        </div>
      </div>

      <button
        style={{ display: "none" }}
        data-bs-toggle="modal"
        data-bs-target="#error"
        id="modalErr"
      ></button>

    </div>
  );
};

export default ModalConfirmacionSeguro;
